import React, { ReactNode } from 'react';
import { FundingCardProps } from 'modules/creditSubmission';
import { EquipmentRevenueCardProps } from 'modules/equipment';
import { AftermarketRevenueCardProps } from 'modules/aftermarket';
import { RevenueProfitCardProps } from 'modules/vendorOpportunity';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { RevenueSummary } from './RevenueSummary';

interface Props {
  voId: string;
  accountId: string;
  dynamicsVOId: string;
  submissionCard: (renderProps: FundingCardProps) => ReactNode;
  profitCard: (renderProps: RevenueProfitCardProps) => ReactNode;
  equipmentCard: (renderProps: EquipmentRevenueCardProps) => ReactNode;
  aftermarketCard: (renderProps: AftermarketRevenueCardProps) => ReactNode;
}

export const RevenueTab = (props: Props) => {
  return (
    <CardContainer>
      <RevenueSummary {...props} />
    </CardContainer>
  );
};
